import { JobApplicationForm, useAnchor } from '@stereoagency/ui';
import Turnstile from 'react-turnstile';
import useTranslation from 'next-translate/useTranslation';
import flush from 'just-flush';
import React from 'react';
import { useQuery } from 'urql';
import { useFragment } from '@/gql';
import { JobSummaryFieldsFragment } from '@/gql/documents/fragments';
import { FindAllJobSummariesQueryDocument } from '@/gql/client/graphql';
import { acfFirst, acfNode } from '@/utils';


function getFormLabelsDict (){
  const { t } = useTranslation();
  // Define the type for the dictionary
  type TranslationDict = {
    [key: string]: {
      label: string;
      placeholder?: string;
    };
  };

  // Initialize the dictionary with the defined type
  const translationDict: TranslationDict = {};
  translationDict.job = {
    label: t('job-application-form:fields.job.label'),
    placeholder: t('job-application-form:fields.job.placeholder')
  };
  translationDict.firstName= {
    label: t('job-application-form:fields.firstName.label'),
    placeholder: t('job-application-form:fields.firstName.placeholder')
  }
  translationDict.lastName ={
    label: t('job-application-form:fields.lastName.label'),
    placeholder: t('job-application-form:fields.lastName.placeholder')
  }
  translationDict.email = {
    label: t('job-application-form:fields.email.label'),
    placeholder: t('job-application-form:fields.email.placeholder')
  }
  translationDict.cv = {
    label: t('job-application-form:fields.cv.label'),
  }
  translationDict.motivationLetter = {
    label: t('job-application-form:fields.motivationLetter.label'),
  }
  translationDict.expectedSalary ={
    label: t('job-application-form:fields.expectedSalary.label'),
  }
  translationDict.startDate = {
    label: t('job-application-form:fields.startDate.label'),
  }
  translationDict.natoNationality = {
    label: t('job-application-form:fields.natoNationality.label'),
    placeholder: t('job-application-form:fields.natoNationality.placeholder')
  }
  translationDict.gdprConsent = {
    label: t('job-application-form:fields.gdprConsent.label'),
  }
  translationDict.aiConsent ={
    label: t('job-application-form:fields.aiConsent.label'),
  }
  return translationDict;
}

// @ts-ignore
export function TurnstileWidget({ setToken }) {
  const [, setStatus] = React.useState()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  return (
    <Turnstile
      sitekey={process.env.TURNSTILE_SITE_KEY ?? ''}
      // @ts-ignore
      onError={() => setStatus('error')}
      // @ts-ignore
      onExpire={() => setStatus('expired')}
      // @ts-ignore
      onVerify={(token) => setToken(token)}
    />
  )
}

export default function NvisoJobApplicationForm() {
  const anchor = useAnchor();
  const [turnstileToken, setToken] = React.useState();
  const [{ data: jobSummariesQueryResult }] = useQuery({
    query: FindAllJobSummariesQueryDocument,
  });
  const translationDict  = getFormLabelsDict()
  // const countJobSummariesQueryResult = jobSummariesQueryResult?.jobs?.nodes?.length || 0;
  const jobsFields = useFragment(JobSummaryFieldsFragment, flush(jobSummariesQueryResult?.jobs?.nodes ?? []));

  const jobsList:  Array<{ jiraTicketID: string; jobTitle: string }>= [];
  jobsFields.forEach((job) => {
    if (job.title && job.cptJobFields?.jiraTicketKey) {
      const office = acfNode(job.cptJobFields?.office, 'Office');
      const country = acfFirst(office?.cptOfficeCustomFields?.country);
      const jobAndCountry = `${job.title} - ${country}`;
      const jiraTicketID = job.cptJobFields.jiraTicketKey.trim();

      jobsList.push({
        jiraTicketID,
        jobTitle: jobAndCountry,
      });
    }
  });


  return (
  <div id={anchor} className="mx-auto max-w-2xl space-y-6 scroll-mt-24">
    <JobApplicationForm jobs={jobsList} turnstileToken={turnstileToken} translationDict={translationDict}/>
    <TurnstileWidget setToken={setToken} />
  </div>
);
}